/**
 * filehelper creates the window.base64toBlob and window.openb64FileDownload function.
 *
 * window.base64toBlob converts base46 to blob format.
 * If a parameter is not given, it is replaced with a dummy variable.
 * - b64Data: ?            (Data to download)
 * - contentType: String   (Filetype to download as, ie 'plain/text')
 * - sliceSize: Int        (Size to slice the blob to, ie '512')
 *
 * window.openb64FileDownload allows to download B64 files.
 * If a parameter is not given, it is replaced with a dummy variable.
 * - b64Data: ?            (Data to download)
 * - filename: String      (Filename to download as, ie 'myfile')
 * - contentType: String   (Filetype to download as, ie 'plain/text')
 */

function filehelper() {
	window.base64toBlob = function(b64Data, contentType, sliceSize) {
		contentType = contentType || '';
		sliceSize = sliceSize || 512;

		const byteCharacters = atob(b64Data);
		const byteArrays = [];

		for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
			const slice = byteCharacters.slice(offset, offset + sliceSize);

			const byteNumbers = new Array(slice.length);
			for (let i = 0; i < slice.length; i++) {
				byteNumbers[i] = slice.charCodeAt(i);
			}

			const byteArray = new Uint8Array(byteNumbers);

			byteArrays.push(byteArray);
		}

		const blob = new Blob(byteArrays, { type: contentType });
		return blob;
	};

	window.openb64FileDownload = function(b64Data, filename, contentType) {
		filename = filename || 'download';
		contentType = contentType || 'plain/text';

		console.log('file download', filename, contentType, b64Data.length);
		const blob = window.base64toBlob(b64Data, contentType);
		if (window.navigator && window.navigator.msSaveOrOpenBlob) {
			window.navigator.msSaveOrOpenBlob(blob, filename);
		} else {
			const a = document.createElement('a');
			a.style = 'display:none';
			document.body.appendChild(a);
			const url = window.URL.createObjectURL(blob);
			a.href = url;
			a.download = filename;
			a.click();
			window.URL.revokeObjectURL(url);
		}
	};
}
filehelper();
